import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { AppShell } from "@/components/AppShell";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import ComplaintsPage from "@/pages/ComplaintsPage";
import EscalationsPage from "@/pages/EscalationsPage";
import UploadPage from "@/pages/UploadPage";
import SettingsPage from "@/pages/SettingsPage";
import WeeklyReportPage from "@/pages/WeeklyReportPage";
import DailyReportsPage from "@/pages/DailyReportsPage";
import OemDelaysPage from "@/pages/OemDelaysPage";
import MonthlyReportsPage from "@/pages/MonthlyReportsPage";
import LoginActivityPage from "@/pages/LoginActivityPage";
import GoogleRatingsPage from "@/pages/GoogleRatingsPage";
import CxScorecardsPage from "@/pages/CxScorecardsPage";
import { Toaster } from "@/components/ui/sonner";
import { Loader2 } from "lucide-react";

const Protected = ({ children, adminOnly }) => {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="animate-spin text-[hsl(var(--cx-navy))]" size={28} />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && !user.permissions?.can_manage_settings) return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            element={
              <Protected>
                <AppShell />
              </Protected>
            }
          >
            <Route path="/" element={<DashboardPage />} />
            <Route path="/complaints" element={<ComplaintsPage />} />
            <Route path="/escalations" element={<EscalationsPage />} />
            <Route path="/report" element={<WeeklyReportPage />} />
            <Route path="/daily-reports" element={<DailyReportsPage />} />
            <Route path="/oem-delays" element={<OemDelaysPage />} />
            <Route path="/google-ratings" element={<GoogleRatingsPage />} />
            <Route path="/cx-scorecards" element={<CxScorecardsPage />} />
            <Route path="/monthly-reports" element={<MonthlyReportsPage />} />
            <Route
              path="/login-activity"
              element={
                <Protected adminOnly>
                  <LoginActivityPage />
                </Protected>
              }
            />
            <Route
              path="/upload"
              element={
                <Protected adminOnly>
                  <UploadPage />
                </Protected>
              }
            />
            <Route
              path="/settings"
              element={
                <Protected adminOnly>
                  <SettingsPage />
                </Protected>
              }
            />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
